<template>
  <div class="chat-container">
    <CustomTitleBar :title="TUITranslateService.t(userName)" :fixed="true" :zIndex="10" />
    <TUIChat> </TUIChat>
  </div>
</template>

<script lang="ts" setup>
import { TUIChat } from "@/TUIKit/components";
import { TUIConversationService } from "@tencentcloud/chat-uikit-engine";
import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted } from "vue";
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref } from "vue";
import { useRoute } from "vue-router";
const conversationType = ref()
const conversationID = ref()
const userName = ref()

onMounted(() => {
  //从路由获取参数
  const route = useRoute()
  //C2C、GROUP
  conversationType.value = route.query.conversationType
  conversationID.value = route.query.conversationID
  userName.value = route.query.userName
  TUIConversationService.switchConversation(conversationType.value + conversationID.value);
})
</script>
<style lang="scss" scoped>
.chat-container {
  height: 100vh;

  ::v-deep .tui-chat-header {
    height: 44px;

    div {
      display: none;
    }
  }
}
</style>
